import { useState, FC } from "react";

const BRAND = "#2563eb";

interface NavbarProps {
  onLogoClick?: () => void;
}

const Navbar: FC<NavbarProps> = ({ onLogoClick }) => {
  const [hoveredLink, setHoveredLink] = useState<string | null>(null);

  const navLinks: string[] = [""];

  return (
    <nav style={{
      display: "flex", alignItems: "center", justifyContent: "space-between",
      padding: "14px 40px", borderBottom: "1px solid #f0ede8",
      background: "#fff", position: "sticky", top: 0, zIndex: 100,
    }}>
      {/* Logo */}
      <div 
        onClick={onLogoClick}
        style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 20, fontWeight: 700, color: BRAND, cursor: "pointer" }}>
        <span style={{ fontSize: 26 }}>📄</span> EasyPDF
      </div>

      {/* Links */}
      <div style={{ display: "flex", alignItems: "center", gap: 28, fontSize: 14 }}>
        {navLinks.map((link) => (
          <span key={link}
            onMouseEnter={() => setHoveredLink(link)}
            onMouseLeave={() => setHoveredLink(null)}
            style={{ cursor: "pointer", color: hoveredLink === link ? BRAND : "#555", transition: "color 0.15s", fontWeight: hoveredLink === link ? 500 : 400 }}>
            {link}
          </span>
        ))}
      </div>

      {/* Actions */}
      {/*<div style={{ display: "flex", gap: 10 }}>*/}
      {/*  <button style={{*/}
      {/*    fontSize: 13, padding: "8px 18px", border: "1px solid #ddd",*/}
      {/*    borderRadius: 8, cursor: "pointer", background: "transparent",*/}
      {/*    color: "#333", fontWeight: 500, transition: "all 0.15s",*/}
      {/*  }}*/}
      {/*    onMouseEnter={(e) => { e.currentTarget.style.borderColor = BRAND; e.currentTarget.style.color = BRAND; }}*/}
      {/*    onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#ddd"; e.currentTarget.style.color = "#333"; }}>*/}
      {/*    Log In*/}
      {/*  </button>*/}
        {/*<button style={{*/}
        {/*  fontSize: 13, padding: "8px 18px", borderRadius: 8, cursor: "pointer",*/}
        {/*  background: BRAND, color: "#fff", border: "none", fontWeight: 600,*/}
        {/*  transition: "background 0.15s",*/}
        {/*}}*/}
        {/*  onMouseEnter={(e) => e.currentTarget.style.background = "#1d4ed8"}*/}
        {/*  onMouseLeave={(e) => e.currentTarget.style.background = BRAND}>*/}
        {/*  Free Trial*/}
        {/*</button>*/}
      {/*</div>*/}
    </nav>
  );
};

export default Navbar;

